{
  "remove": "Удалить"
}
